import isEmpty from 'lodash/isEmpty';

import { useScreenMessage } from '@gogame/screens';

import {
  USER_SETTINGS_SCREEN_NAME,
  PRESETS_PERIOD,
} from 'scenes/HomeDashboard/constants';
import { loadUserSettings } from 'scenes/HomeDashboard/sources/user';

import { useSaveUserSettings } from './useSaveUserSettings';

const localStorageName = 'HomeDashboard';

// TODO: temporary
const migrationWidgets = ({ widgets = [], ...data }) => ({
  ...data,
  widgets: widgets
    .filter(item => !isEmpty(Array.isArray(item) ? item[0] : item))
    .map(item => (Array.isArray(item) ? item : [item])),
});

export const useLoadUserSettings = () => {
  const { showErrorMessage } = useScreenMessage();
  const saveUserSettings = useSaveUserSettings();

  return () =>
    loadUserSettings({ keys: [USER_SETTINGS_SCREEN_NAME] })
      .then(data => {
        if (data && data[USER_SETTINGS_SCREEN_NAME]) {
          return migrationWidgets(data[USER_SETTINGS_SCREEN_NAME]);
        }

        // TODO: temporary
        const localStorage = JSON.parse(
          window.localStorage.getItem(localStorageName)
        );

        const normalizedLocalStorage = {
          filters: {
            presets:
              localStorage && localStorage.widgets
                ? localStorage.widgets.map(({ id }) => id)
                : [],
            period: (localStorage && localStorage.period) || [PRESETS_PERIOD],
          },
          widgets:
            localStorage && localStorage.widgets
              ? localStorage.widgets.map(({ id }) => ({ id }))
              : [],
        };

        return saveUserSettings(migrationWidgets(normalizedLocalStorage)).then(
          data => {
            window.localStorage.removeItem(localStorageName);
            return data[USER_SETTINGS_SCREEN_NAME];
          }
        );
      })
      .catch(e => {
        showErrorMessage(e.message, { multiple: Array.isArray(e.message) });
        return Promise.reject(e);
      });
};
